'use client';

import _defineProperty from "/codebuild/output/src2820/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src2820/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["style"],
  _excluded2 = ["forceMount"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx } from 'react/jsx-runtime';
import { forwardRef, useRef, useEffect } from 'react';
import { useMergedRef, useDebouncedCallback } from '@mantine/hooks';
import { useScrollAreaContext } from '../ScrollArea.context.mjs';
import { useScrollbarContext } from '../ScrollAreaScrollbar/Scrollbar.context.mjs';
import { composeEventHandlers } from '../utils/compose-event-handlers.mjs';
import { addUnlinkedScrollListener } from '../utils/add-unlinked-scroll-listener.mjs';
var Thumb = forwardRef(function (props, forwardedRef) {
  var style = props.style,
    others = _objectWithoutProperties(props, _excluded);
  var scrollAreaContext = useScrollAreaContext();
  var scrollbarContext = useScrollbarContext();
  var onThumbPositionChange = scrollbarContext.onThumbPositionChange;
  var composedRef = useMergedRef(forwardedRef, function (node) {
    return scrollbarContext.onThumbChange(node);
  });
  var removeUnlinkedScrollListenerRef = useRef();
  var debounceScrollEnd = useDebouncedCallback(function () {
    if (removeUnlinkedScrollListenerRef.current) {
      removeUnlinkedScrollListenerRef.current();
      removeUnlinkedScrollListenerRef.current = void 0;
    }
  }, 100);
  useEffect(function () {
    var viewport = scrollAreaContext.viewport;
    if (viewport) {
      var handleScroll = function handleScroll() {
        debounceScrollEnd();
        if (!removeUnlinkedScrollListenerRef.current) {
          var listener = addUnlinkedScrollListener(viewport, onThumbPositionChange);
          removeUnlinkedScrollListenerRef.current = listener;
          onThumbPositionChange();
        }
      };
      onThumbPositionChange();
      viewport.addEventListener("scroll", handleScroll);
      return function () {
        return viewport.removeEventListener("scroll", handleScroll);
      };
    }
    return void 0;
  }, [scrollAreaContext.viewport, debounceScrollEnd, onThumbPositionChange]);
  return /* @__PURE__ */jsx("div", _objectSpread(_objectSpread({
    "data-state": scrollbarContext.hasThumb ? "visible" : "hidden"
  }, others), {}, {
    ref: composedRef,
    style: _objectSpread({
      width: "var(--sa-thumb-width)",
      height: "var(--sa-thumb-height)"
    }, style),
    onPointerDownCapture: composeEventHandlers(props.onPointerDownCapture, function (event) {
      var thumb = event.target;
      var thumbRect = thumb.getBoundingClientRect();
      var x = event.clientX - thumbRect.left;
      var y = event.clientY - thumbRect.top;
      scrollbarContext.onThumbPointerDown({
        x: x,
        y: y
      });
    }),
    onPointerUp: composeEventHandlers(props.onPointerUp, scrollbarContext.onThumbPointerUp)
  }));
});
var ScrollAreaThumb = forwardRef(function (props, forwardedRef) {
  var forceMount = props.forceMount,
    thumbProps = _objectWithoutProperties(props, _excluded2);
  var scrollbarContext = useScrollbarContext();
  if (forceMount || scrollbarContext.hasThumb) {
    return /* @__PURE__ */jsx(Thumb, _objectSpread({
      ref: forwardedRef
    }, thumbProps));
  }
  return null;
});
export { ScrollAreaThumb, Thumb };